/** Registers the NinePatchRect parser. `index.r3f.ts` registers the render side. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseNinePatchRect } from './parser';
const ninePatchRectRegistration = {
    typeName: 'NinePatchRect',
    parser: parseNinePatchRect,
};
nodeRegistry.register(ninePatchRectRegistration);
//# sourceMappingURL=index.js.map